import { z } from "zod";
import { isoAndUnixZodSchema } from "../../date-time/iso-and-unix";
import { iconNameZodString } from "../../icon-name";
import { labelZodObject } from "../../labels/label";
import { productIdZodSchema } from "../../products/product-id";
import { providerIdZodSchema } from "../../providers/provider-id";
import {
    requiredTranslatableZodSchema,
    translatableZodSchema,
} from "../../translations/translation";
import { userIdZodSchema } from "../../users/user-id";
import { productFormIdZodSchema } from "../product-form-id";
import { productFormFieldIdZodSchema } from "./product-form-field-id";
import { productFormFieldQuantityZodUnion } from "./product-form-field-quantity";

const productFormFieldBaseZodObject = z.object({
    _id: productFormFieldIdZodSchema,
    _type: z.literal("PRODUCT_FIELD"),
    _createdAt: isoAndUnixZodSchema,
    _createdBy: userIdZodSchema,
    type: z.never(),
    quantity: productFormFieldQuantityZodUnion,
    productFormId: productFormIdZodSchema,
    productId: productIdZodSchema,
    providerId: providerIdZodSchema,
    title: requiredTranslatableZodSchema,
    description: translatableZodSchema.optional(),
    iconName: iconNameZodString.optional(),
    labels: z.array(labelZodObject),
});

type ProductFormFieldBase = z.infer<typeof productFormFieldBaseZodObject>;

export { productFormFieldBaseZodObject };
export type { ProductFormFieldBase };
